import React, { useCallback, useEffect, useRef } from "react";
import { useMerchant } from "@zkt/eb-utility";
import {
  CustomStyleHotels,
  CustomTheme,
  TypeBoardCustomTheme,
  // defaultColorConfiguration,
  hexToRgba,
  specialHandling,
} from "./constants";

import ZktLogo from "@/assets/logo.svg";

interface PageAppProps {
  customThemeStyles: TypeBoardCustomTheme;
  callback: (logo: string, lw: number, lh: number) => void;
}

export default function CustomStyle(props: PageAppProps): JSX.Element {
  const { merchant } = useMerchant();
  const { callback, customThemeStyles } = props;
  const styleElement = useRef<HTMLStyleElement>(null);
  // const [customThemeStyles, setCustomThemeStyles] =
  //   useState<TypeBoardCustomTheme>(null);
  const modalityEntirety = useCallback(
    (hotelCustomTheme, merchantId) => {
      const {
        logoUrl,
        logoWidth,
        logoHeight,
        brandName,
        primaryColor,
        slaveColor,
        slaveTransparent,
        slaveTextColor,
        sideBarBgColor,
        sideBarSelectedBgColor,
      } = hotelCustomTheme;
      styleElement.current = document.createElement("style");
      styleElement.current.setAttribute("type", "text/css");
      styleElement.current.setAttribute("data-custom", brandName);
      // 通过回调设置 logo
      if (logoUrl) {
        callback(logoUrl, logoWidth, logoHeight);
      }
      // Link
      styleElement.current.innerHTML = `a.ant-typography, .ant-typography a {color:${primaryColor}!important;}`;
      // 单选按钮
      styleElement.current.innerHTML += `.ant-radio-inner::after {background-color:${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.ant-radio-checked .ant-radio-inner {border-color:${primaryColor}!important;}`;
      // 复选框
      styleElement.current.innerHTML += `.ant-checkbox-checked .ant-checkbox-inner {background-color:${primaryColor}!important;}`;
      // Button hover 样式
      styleElement.current.innerHTML += `.ant-btn:hover {color:${slaveTextColor}!important;border-color:${primaryColor}!important;}`;

      styleElement.current.innerHTML += `.ant-btn-link:hover {color:${primaryColor}!important;border-color:${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.ant-btn.ant-btn-default:hover {color:${primaryColor}!important;border-color:${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.ant-btn-special:hover {color:${primaryColor}!important;}`;
      // Button focus 样式
      styleElement.current.innerHTML += `.ant-btn:focus, .ant-btn-link:focus {color:${primaryColor}!important;border-color:${primaryColor}!important;}`;
      // Button active 样式
      styleElement.current.innerHTML += `.ant-btn:active, .ant-btn-link:active {color:${primaryColor}!important;border-color:${primaryColor}!important;background-color:#fff!important;}`;
      // Button 样式
      styleElement.current.innerHTML += `.ant-btn-primary {background-color:${slaveColor}!important;}`;
      styleElement.current.innerHTML += `.ant-btn-primary {color:${slaveTextColor}!important;}`;
      styleElement.current.innerHTML += `.ant-btn-primary:focus {color:${slaveTextColor}!important;}`;
      styleElement.current.innerHTML += `.ant-btn-link,.ant-btn-text {color:${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.ant-btn-special {color: ${primaryColor}!important; border-color:${primaryColor}!important;}`;
      // Button 内部的 icon 颜色
      styleElement.current.innerHTML += `.ant-btn-primary svg.icon {fill: ${slaveTextColor}}`;
      // 输入框
      styleElement.current.innerHTML += `.ant-input:hover,.ant-input-number-input:hover {border-color:${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.ant-form .ant-input:focus {border-color:${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.ant-input-number:hover {border-color:${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.ant-input:active, .ant-input-number:active {border-color:${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.ant-input:focus, .ant-input-focused, .ant-input-number:focus, .ant-input-number-focused {border-color:${primaryColor}!important;box-shadow:none!important;}`;
      // placeholder
      styleElement.current.innerHTML += `input::-webkit-input-placeholder { color: #b9b9b9; }`;
      styleElement.current.innerHTML += `input:-moz-placeholder { color: #b9b9b9; }`;
      styleElement.current.innerHTML += `input::-moz-placeholder { color: #b9b9b9; }`;
      // 下拉框
      styleElement.current.innerHTML += `.ant-select:not(.ant-select-customize-input) .ant-select-selector:hover  {border-color:${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.ant-select:hover {border-color:${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.ant-select-open,.ant-select-focused .ant-select-selector {border-color:${primaryColor}!important;}`;
      // 日历选择
      styleElement.current.innerHTML += `.ant-picker:hover, .ant-picker-focused {border-color:${primaryColor}!important;}`;
      // tab
      styleElement.current.innerHTML += `.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {color:${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.ant-tabs-tab:hover {color:${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.ant-tabs-ink-bar {background:${primaryColor}!important;}`;
      // radio button
      styleElement.current.innerHTML += `.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {background-color:${slaveColor}!important;color:${slaveTextColor}!important;border:${slaveColor};}`;
      styleElement.current.innerHTML += `.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {background-color:${slaveColor}!important;}`;
      styleElement.current.innerHTML += `.ant-radio-button-wrapper:hover {color: ${slaveTextColor}!important;}`;
      // 侧边栏
      // 侧边栏选中菜单背景色
      styleElement.current.innerHTML += `.ant-menu-item-selected {background: linear-gradient(90deg, ${slaveColor} 0%, ${slaveColor} 99%)!important;}`;
      // 侧边栏选中菜单文字色
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider .ant-menu .ant-menu-item-selected span.ant-badge {color:${slaveTextColor}!important;}`;
      // ？
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider .ant-layout-sider-children {background-color:${sideBarBgColor}!important;background-image:none;}`;

      // 侧边栏选项背景色
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider .ant-menu-submenu-open {background-color:${sideBarSelectedBgColor}!important;}`;
      // 侧边栏选项 hover
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider .ant-menu-item:hover {background: linear-gradient(90deg, ${slaveColor} 0%, ${slaveColor} 99%)!important;}`;
      // hover 时修改菜单文字色
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider .ant-menu-item:hover span.ant-badge {color:${slaveTextColor}!important;}`;

      // 侧边栏选项(有子菜单的条目) hover
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider div.ant-menu-submenu-title:hover {background: linear-gradient(90deg, ${slaveColor} 0%, ${slaveColor} 99%)!important;}`;
      // hover 时修改菜单文字色
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider div.ant-menu-submenu-title:hover span.ant-badge {color:${slaveTextColor}!important;}`;
      // hover 时修改icon颜色 .eb-master .main-index-navbar.ant-layout-sider
      styleElement.current.innerHTML += `div.ant-menu-submenu-title:hover svg.ant-menu-item-icon, .ant-menu-item:hover svg.ant-menu-item-icon {color:${slaveTextColor}!important;}`;
      // hover 时修改菜单旁边的箭头颜色
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider div.ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before {background:${slaveTextColor}!important;}`;
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider div.ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after {background:${slaveTextColor}!important;}`;

      // ant-menu-submenu
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider .ant-menu-submenu-title:hover {background: linear-gradient(90deg, ${primaryColor} 0%, ${primaryColor} 99%)!important;}`;
      // 侧边栏：左下方 copyright 区域
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider footer {background:none;color:#666666;}`;
      // 侧边栏菜单搜索框背景色
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider .ant-layout-sider-children .search-box-container .search-box {background:${sideBarSelectedBgColor}!important;}`;
      // 侧边栏搜索关键词高亮
      styleElement.current.innerHTML += `.eb-master .main-index-navbar.ant-layout-sider mark {color: ${slaveColor}!important;}`;

      // 翻页条
      styleElement.current.innerHTML += `.ant-pagination-item-active {background-color: ${primaryColor}!important;border-color: ${primaryColor}!important;}`;

      // ICON
      styleElement.current.innerHTML += `.eb-room .action-icon {color: ${primaryColor}!important;}`;
      // 右上角通知
      styleElement.current.innerHTML += `.anticon.ant-notification-notice-icon-info {color: ${primaryColor}!important;}`;
      // tag
      styleElement.current.innerHTML += `.ant-tag.tag {background: ${slaveColor}; color: ${slaveTextColor}!important;}`;
      // top icon
      styleElement.current.innerHTML += `svg.icon {fill: ${primaryColor}}`;

      // 其他业务线样式调整
      styleElement.current.innerHTML += `.eb-room .show-more {color: ${primaryColor}!important;}`;
      // 预售券产品列表标签、储值卡产品列表标签
      styleElement.current.innerHTML += `.eb-room span.ant-tag.tag, .eb-card .custom-tag {background: ${slaveTransparent}; color: ${slaveTextColor}!important;border-color:${slaveColor};}`;
      // 预售券批量标签设置
      styleElement.current.innerHTML += `.batchOperation .card>.ant-card-body h4.ant-typography {color: ${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.eb-room .zkt-showMore-container {color: ${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.eb-room .zkt-btn-style {color: ${primaryColor}!important;border: solid 1px ${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.eb-room .zkt-tagName-box>span {color: ${primaryColor}!important}`;
      // 房型信息 操作 icon
      styleElement.current.innerHTML += `.eb-room .roomtype_root svg.c4C68EF {color: ${primaryColor}!important;}`;
      // 房价代码维护
      styleElement.current.innerHTML += `.eb-room .promotion-content .icon-room {color: ${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.eb-room .BasicPrice .card-list a {color: ${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.expand-table-cell svg.icon-caret-right-fill {color: ${primaryColor}!important; fill: ${primaryColor}!important;}`;
      // https://test5-eb.zhiketong.net/room/promotions
      styleElement.current.innerHTML += `.eb-room .promotion-content .preview-content .expand-arrow {background:${primaryColor}!important;}`;
      // 客房订单
      styleElement.current.innerHTML += `.eb-room .room-list-container .list-container .list-card .list-card-box .box-heade .status {color: ${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.eb-room .room-list-container .list-container .list-card .hover-list-card-box {border: solid 1px ${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.eb-room .order_layout .card .check-detail {color: ${primaryColor}!important;}`;
      styleElement.current.innerHTML += `.eb-room .order_layout .commonTittle .linetitle .line {background: ${primaryColor}!important;}`;
      styleElement.current.innerHTML += `small.text-primary {color: ${primaryColor}!important;}`;

      // 储值卡
      styleElement.current.innerHTML += `.eb-card .icon-button {color: ${primaryColor}!important;}`;

      // 针对朗庭子酒店特殊处理
      if (specialHandling.includes(merchantId)) {
        styleElement.current.innerHTML += `.ant-link-money {color: #486bf4 !important;}`;
        styleElement.current.innerHTML += `.ant-link-money:hover {color: #486bf4 !important;}`;
      }
      // 消息图标特殊处理
      styleElement.current.innerHTML += `.icon-lighting-bulb {fill: #E58A5F !important;}`;

      document.head.appendChild(styleElement.current);
    },
    [callback]
  );

  useEffect(() => {
    if (!customThemeStyles) {
      return () => {
        console.log("custom style components load error : no hotel");
      };
    }
    const { merchantId } = merchant;
    try {
      // 如果接口isOpen为1那就走配置,如果不为那就走以前的逻辑
      const customTheme = customThemeStyles.customThemeJson;
      if (customTheme && customThemeStyles.isOpen === "1") {
        // 解析
        const data = JSON.parse(customThemeStyles.customThemeJson);
        // 特殊处理(储值卡创建页面-赠送礼包)
        // "data.slaveColor" -- 按钮背景色、菜单选中色，他们颜色一样但是slaveTransparent得有一个透明度
        if (data.slaveColor) {
          data.slaveTransparent = hexToRgba(data.slaveColor, 0.42);
        }
        // 如果某一项为空就使用默认配置补充上
        // Object.keys(defaultColorConfiguration).forEach((item) => {
        //   if (!data[item]) {
        //     data[item] = defaultColorConfiguration[item];
        //   }
        // });
        // 写入样式单独抽出封装(传入配置)
        modalityEntirety(data, merchantId);
      } else {
        throw new TypeError("读取默认配置");
      }
    } catch (erre) {
      let hotelCustomTheme: CustomTheme;
      CustomStyleHotels.forEach((value: CustomTheme, key: number[]) => {
        if (key.includes(merchantId)) {
          hotelCustomTheme = value;
        }
      });

      if (!hotelCustomTheme) {
        return () => {
          console.log(
            "custom style components load info : current hotel not in config"
          );
        };
      }
      // 写入样式链接,单独抽出封装(读取之前的配置)
      modalityEntirety(hotelCustomTheme, merchantId);
    }
    // 清除style
    return () => {
      if (styleElement.current) {
        document.head.removeChild(styleElement.current);
      }
      callback(ZktLogo, 79, 21);
    };
  }, [merchant, callback, modalityEntirety, customThemeStyles]);

  return <></>;
}
